import { render, staticRenderFns } from "./grouppage.vue?vue&type=template&id=1cc20ef5&scoped=true"
import script from "./grouppage.vue?vue&type=script&lang=js"
export * from "./grouppage.vue?vue&type=script&lang=js"
import style0 from "./grouppage.vue?vue&type=style&index=0&id=1cc20ef5&prod&lang=css"
import style1 from "./grouppage.vue?vue&type=style&index=1&id=1cc20ef5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc20ef5",
  null
  
)

export default component.exports